import { render } from "./AppSprinklrConnectSystem.vue?vue&type=template&id=0212370a&scoped=true&ts=true"
import script from "./AppSprinklrConnectSystem.vue?vue&type=script&lang=ts"
export * from "./AppSprinklrConnectSystem.vue?vue&type=script&lang=ts"

import "./AppSprinklrConnectSystem.vue?vue&type=style&index=0&id=0212370a&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0212370a"]])

export default __exports__